module.exports = __webpack_public_path__ + "media/quality.6192cab2.mp4";